import type { RouteRecordRaw } from 'vue-router';
import { ENABLE_ADD_STORE } from '@/consts';

// Mỗi screen tự define full route (layout + path tuyệt đối + meta) trong pages/<slug>/route.ts.
// File này CHỈ import + gom — không tự define route object nào.
import { giftCardRoutes } from '@/pages/gift-card';
import { promotionManagementRoutes } from '@/pages/promotion-management';
import { bannerManagementRoutes } from '@/pages/banner-management';
import { deviceManagementRoutes } from '@/pages/device-management';
import { billingDetailRoutes, billingDetailRedirects } from '@/pages/billing-detail';
import { employeeCheckinRoutes, employeeRedirects } from '@/pages/employee-checkin';
import { employeeManagementRoutes } from '@/pages/employee-management';
import { storeRoutes, storeRedirects } from '@/pages/add-store';
import { signinRoutes, authRedirects } from '@/pages/signin';
import { signupRoutes } from '@/pages/signup';
import { forgotPasswordRoutes } from '@/pages/forgot-password';
import { resetPasswordRoutes } from '@/pages/reset-password';
import { confirmEmailRoutes } from '@/pages/confirm-email';
import { staffLoginRoutes } from '@/pages/staff-login';
import { customerReviewRoutes } from '@/pages/customer-review';
import { reviewsRoutes, reviewRedirects } from '@/pages/reviews';
import { serviceManagementRoutes, serviceRedirects } from '@/pages/service-management';
import { turnTrackerRoutes } from '@/pages/turn-tracker';
import { customerMgmtV2Routes } from '@/pages/customer-mgmt-v2';
import { promotionBannerRoutes } from '@/pages/promotion-banner';
import { userRoutes } from '@/pages/user';
import { bookAppointmentRoutes } from '@/pages/book-appointment';
import { createAppointmentRoutes } from '@/pages/create-appointment';
import { customerCheckinRoutes, customerCheckinRedirects } from '@/pages/customer-checkin';
import { customerCheckinListRoutes } from '@/pages/customer-checkin-list';
import { setupRoutes, setupRedirects } from '@/pages/setup';
import { setupStoreRoutes } from '@/pages/setup-store';
import { setupPaymentMethodRoutes } from '@/pages/setup-payment-method';
import { setupAdminRoutes } from '@/pages/setup-admin';
import { setupCheckoutRoutes } from '@/pages/setup-checkout';
import { setupTurnTrackerRoutes } from '@/pages/setup-turn-tracker';
import { setupStoreLandingRoutes } from '@/pages/setup-store-landing';
import { customerCheckoutRoutes } from '@/pages/customer-checkout';
import { pricingRoutes } from '@/pages/pricing';
import { onboardingRoutes } from '@/pages/onboarding';
import { spinCampaignsRoutes } from '@/pages/spin-campaigns';
import { createSpinCampaignRoutes } from '@/pages/create-spin-campaign';
import { editSpinCampaignRoutes } from '@/pages/edit-spin-campaign';
import { spinCampaignDetailRoutes } from '@/pages/spin-campaign-detail';
import { spinCustomerRoutes } from '@/pages/spin-customer';
import { reportRoutes } from '@/pages/report';
import { notFoundRoutes } from '@/pages/error-404';

const routes: RouteRecordRaw[] = [
  giftCardRoutes,
  promotionManagementRoutes,
  bannerManagementRoutes,
  deviceManagementRoutes,
  billingDetailRoutes,
  ...billingDetailRedirects,
  employeeCheckinRoutes,
  employeeManagementRoutes,
  ...employeeRedirects,
  // Gate chung một flag: storeRedirects trỏ tới route name ADD_STORE.
  ...(ENABLE_ADD_STORE ? [storeRoutes, ...storeRedirects] : []),
  signinRoutes,
  signupRoutes,
  forgotPasswordRoutes,
  resetPasswordRoutes,
  confirmEmailRoutes,
  staffLoginRoutes,
  ...authRedirects,
  customerReviewRoutes,
  reviewsRoutes,
  ...reviewRedirects,
  serviceManagementRoutes,
  ...serviceRedirects,
  turnTrackerRoutes,
  customerMgmtV2Routes,
  promotionBannerRoutes,
  userRoutes,
  bookAppointmentRoutes,
  createAppointmentRoutes,
  customerCheckinRoutes,
  customerCheckinListRoutes,
  ...customerCheckinRedirects,
  setupRoutes,
  setupStoreRoutes,
  setupPaymentMethodRoutes,
  setupAdminRoutes,
  setupCheckoutRoutes,
  setupTurnTrackerRoutes,
  setupStoreLandingRoutes,
  ...setupRedirects,
  customerCheckoutRoutes,
  pricingRoutes,
  onboardingRoutes,
  spinCampaignsRoutes,
  createSpinCampaignRoutes,
  editSpinCampaignRoutes,
  spinCampaignDetailRoutes,
  spinCustomerRoutes,
  reportRoutes,
  notFoundRoutes,
];

export default routes;
